/**
 * FILE: apps/hub/src/hooks/auth-context.ts
 * PURPOSE: Custom React hook.
 * AGENT_CONTEXT: Reusable logic. Follow Rules of Hooks. No side effects in render.
 * LAST_REVIEWED: 2026-05-07
 */

import { createContext } from 'react'
import { useAuthStore } from '@/store/auth-store'

export interface AuthContextValue {
  status: 'loading' | 'authenticated' | 'unauthenticated'
  identity: ReturnType<typeof useAuthStore.getState>['identity']
  refresh: () => Promise<void>
  logout: () => Promise<void>
}

export const AuthContext = createContext<AuthContextValue | null>(null)
